import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const SpaceDefaultsPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SpaceDefaultsPageRouteComponent" */ './SpaceDefaultsPageRouteComponent.tsx'
		),
});

export const SpaceDefaultsPageRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <SpaceDefaultsPageRouteComponent />;

SpaceDefaultsPageRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'spaceDefaultsPermissionsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
